
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"opacity":".4","d":"M32 16c0 8.837-7.163 16-16 16S0 24.837 0 16 7.163 0 16 0s16 7.163 16 16z","fill":"#fff"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M16 28.8c7.07 0 12.8-5.731 12.8-12.8 0-7.07-5.73-12.8-12.8-12.8S3.2 8.93 3.2 16c0 7.069 5.73 12.8 12.8 12.8zM11.497 9.06c.222-.238.505-.361.83-.361h4.378c1.247 0 2.292.21 3.117.65.81.432 1.41.996 1.776 1.7a4.73 4.73 0 01.533 2.212c0 .79-.177 1.528-.533 2.212-.366.704-.966 1.269-1.776 1.7-.825.441-1.87.65-3.117.65H13.51v3.81c0 .325-.123.608-.36.83a1.135 1.135 0 01-.823.333c-.32 0-.602-.112-.826-.337a1.135 1.135 0 01-.338-.827V9.882c0-.318.111-.599.334-.823zm2.013 1.89v4.622h3.022c1.285 0 2.1-.249 2.539-.666l.002-.002c.476-.442.71-.983.71-1.643s-.234-1.2-.71-1.642l-.002-.003c-.439-.417-1.255-.666-2.54-.666h-3.02z","fill":"#fff"}})])
          )
        }
      }
    